import React from "react";
import { useTranslation } from "react-i18next";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Heart, Users, BookOpen, MessageCircle, Lightbulb, Shield } from "lucide-react";

const ServicesSection = () => {
  const { t } = useTranslation();
  
  const services = [
    {
      icon: Heart,
      title: t('services.relationship.title'),
      description: t('services.relationship.description'),
    },
    {
      icon: Users,
      title: t('services.family.title'),
      description: t('services.family.description'),
    },
    {
      icon: BookOpen,
      title: t('services.education.title'),
      description: t('services.education.description'),
    },
    {
      icon: MessageCircle,
      title: t('services.listening.title'),
      description: t('services.listening.description'),
    },
    {
      icon: Lightbulb,
      title: t('services.growth.title'),
      description: t('services.growth.description'),
    },
    {
      icon: Shield,
      title: t('services.crisis.title'),
      description: t('services.crisis.description'),
    },
  ];

  return (
    <section id="services" className="py-20 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-4xl lg:text-5xl font-serif font-bold text-[#2C3E50]">
            {t('services.title')}
          </h2>
          <div className="h-1 w-24 bg-[#7C9885] mx-auto"></div>
          <p className="text-lg text-[#5A6B6C] max-w-3xl mx-auto mt-6">
            {t('services.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const IconComponent = service.icon;
            return (
              <Card
                key={index}
                className="border-2 border-[#EDE7DC] hover:border-[#7C9885] transition-all duration-300 hover:shadow-xl bg-[#FEFDFB] group"
              >
                <CardHeader>
                  <div className="w-14 h-14 bg-[#7C9885]/10 rounded-lg flex items-center justify-center mb-4 group-hover:bg-[#7C9885] transition-colors duration-300">
                    <IconComponent className="w-7 h-7 text-[#7C9885] group-hover:text-white transition-colors duration-300" />
                  </div>
                  <CardTitle className="text-xl font-serif text-[#2C3E50]">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-[#5A6B6C] leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;